import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { Sgkd010dSearchResult } from '../../models/sgkd010d-search-result';
import { UsedSgkd010dSgkd022aService } from '../../services/used-sgkd010d-sgkd022a.service';
import { UsedSgkd010dSgkd038aService } from '../../services/used-sgkd010d-sgkd038a.service';
import {
  Sgkd030aResponseAccounttransferrequestReturninfo,
  Sgkd038aRequestUpdateInfoArea,
  Sgkd022aRequestKozadisadReqretInfoarea
} from 'sg-api';
import { MoneyFormatService } from '../../../../../../sg-base/sg-base-shared/services/money-format.service';
import { Router } from '@angular/router';
import { SgKdConstants } from '../../../../../sg-kd-shared/sg-kd-constants';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-sgkd010d-search-result',
  templateUrl: './sgkd010d-search-result.component.html',
  styleUrl: './sgkd010d-search-result.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgkd010dSearchResultComponent implements OnInit, OnDestroy {

  private onDestroy$ = new Subject();

  /** メインフォーム */
  mainForm: UntypedFormGroup;
  /** 結果フラグ */
  hasResult: boolean = false;

  /** メッセージクリア通知イベント */
  @Output() clearMessageEvent = new EventEmitter<string>();
  /** メッセージ設定通知イベント */
  @Output() setMessageEvent = new EventEmitter<string>();

  /** 出力ボタン表示フラグ */
  dispOutputButton: boolean = false;

  /** テーブル表示カラム*/
  displayedColumnsCol: string[] = [
    'outputState',
    'reqretBankfcCode',
    'kouzaFrikaeDate',
    'reqReturnDeadline',
    'bankfcCode',
    'bankfcMei',
    'branchCode',
    'branchMei',
    'item',
    'accntn',
    'frikaeMny',
    'depositpersonMeigi',
    'kokyakuNo',
    'payCtrNo',
    'aceptBaseCompany',
    'aceptBaseSosiki',
    'aceptTntsh'
  ];

  /** 検索結果 */
  dataSource: MatTableDataSource<Sgkd010dSearchResult>;
  /** 選択行情報 */
  selection: SelectionModel<Sgkd010dSearchResult> = new SelectionModel<Sgkd010dSearchResult>(true, []);

  constructor(
    private router: Router,
    private parent: FormGroupDirective,
    private usedSgkd010dSgkd022aService: UsedSgkd010dSgkd022aService,
    private usedSgkd010dSgkd038aService: UsedSgkd010dSgkd038aService,
    private moneyFormatService: MoneyFormatService) {
  }

  /**
   * 初期処理
   * 
   * @memberof Sgkd010dSearchResultComponent
   */
  ngOnInit(): void {
    this.mainForm = this.parent.form;
    //テーブル表示データ作成
    this.dataSource = new MatTableDataSource<Sgkd010dSearchResult>();
  }

  /**
   * 破棄処理
   * 
   * @memberof Sgkd010dSearchResultComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  /**
   * 検索結果設定
   * 
   * @param resultList 検索結果
   * @memberof Sgkd010dSearchResultComponent
   */
  setResult(resultList: Array<Sgkd030aResponseAccounttransferrequestReturninfo>, outputfinishRequestreturndisplayFlg: string): void {

    this.dispOutputButton = false;
    if (outputfinishRequestreturndisplayFlg === SgKdConstants.FLG.OFF) {
      this.dispOutputButton = true;
    }
    
    this.dataSource = new MatTableDataSource<Sgkd010dSearchResult>();
    resultList.forEach((result, index) => {
      let formatFrikaeMny = '';
      if (result.frikaeMny !== null && result.frikaeMny !== undefined && result.frikaeMny !== SgKdConstants.STR.EMPTY) {
        formatFrikaeMny = this.moneyFormatService.formatMoney(result.frikaeMny) + '円';
      }
      
      let dispResult: Sgkd010dSearchResult = {
        outputState: result.outputState,
        reqretBankfcCode: result.reqretFinancialinstitutioncode,
        kouzaFrikaeDate: this.convertStringToDate(result.frikaedate),
        reqReturnDeadline: this.convertStringToDate(result.reqretDeadline),
        bankfcCode: result.bankfcCode,
        bankfcMei: result.bankfcMei,
        branchCode: result.brnccd,
        branchMei: result.branchname,
        item: result.item,
        accntn: result.kouzaNo,
        formatFrikaeMny: formatFrikaeMny,
        frikaeMny: result.frikaeMny,
        depositpersonMeigi: result.depositpersonMeigi,
        payCtrNo: result.payCtrNo,
        claimChargeNo: result.claimChargeNo,
        aceptBaseCompany: result.acceptbaseCompany,
        aceptBaseSosiki: result.acceptbaseSosiki,
        aceptTntsh: result.aceptTntsh,
        reqretSijiMno: result.reqretSijiMno,
        reqretSijiDate: result.reqretSijiDate,
        hakkoYmt: result.hakkoYmt,
        customerNo: result.customerNo,
        kokyakuNo_base: ['payCtrNo', 'claimChargeNo'],
        get kokyakuNo() {
          return this.kokyakuNo_base.map(k => this[k]).join('');
        }
      }
      this.dataSource.data.push(dispResult);
    });
    this.hasResult = true;
  }

  /**
   * 検索結果行クリック処理
   *
   * @memberof Sgkd010dSearchResultComponent
   */
  clickRow(row: Sgkd010dSearchResult): void {

    // 受付基盤UIのURL取得
    const url: string = (window as any).__env.ACEPTBASE_UI_BASE_PATH;

    // anyタイプのパラメータ
    let paramToOutside: any = {};

    // お客さま番号
    let customerNo: string = row.customerNo;
    // 支払契約番号
    let paymentContractNo: string = row.payCtrNo;

    // パラメータ設定
    // お客さま番号
    if (customerNo) {
      paramToOutside.c__customerNo = customerNo;
    }
    // 支払契約番号
    if (paymentContractNo) {
      paramToOutside.c__paymentContractNo = paymentContractNo;
    }

    // 起動元画面
    paramToOutside.c__launchSourceScreen = '15';

    //  anyタイプをクエリ文字列に変換
    let params: string = new URLSearchParams(paramToOutside).toString();
    if (params) {
      params = '?' + params;
    };

    // 別タブで該当URLを開く
    window.open(`${url}${params}`, '_blank');

  }

  /**
   * 出力ボタン押下処理
   * 
   * @memberof Sgkd010dSearchResultComponent 
   */
  onClickPrint(): void {

    // 口座振替依頼返却内訳表データ作成API呼出し
    let accounttransferrequestReturnInformationlist: Array<Sgkd022aRequestKozadisadReqretInfoarea> = [];
    this.dataSource.data.forEach(data => {
      accounttransferrequestReturnInformationlist.push({
        reqretFinancialinstitutioncode: data.reqretBankfcCode,
        bankfcCode: data.bankfcCode,
        brnccd: data.branchCode,
        item: data.item,
        kouzaNo: data.accntn,
        frikaeMny: data.frikaeMny,
        depositpersonMeigi: data.depositpersonMeigi,
        payCtrNo: data.payCtrNo,
        reqretSijiMno: data.reqretSijiMno,
        reqretSijiDate: data.reqretSijiDate,
        hakkoYmt: data.hakkoYmt,
        claimChargeNo: data.claimChargeNo
      });
    });
    this.usedSgkd010dSgkd022aService.print(accounttransferrequestReturnInformationlist)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
      }, error => {
      });

    // 請求料金関連情報登録更新API呼出し
    let updateInfoArea: Array<Sgkd038aRequestUpdateInfoArea> = [];
    this.dataSource.data.forEach(data => {
      updateInfoArea.push({
        updatetargetClaimKeyinfo: {
          hakkoYmt: data.hakkoYmt,
          claimChargeNo: data.claimChargeNo 
        },
        updatetargetinfoClaimdiv: {
          claimDiv: SgKdConstants.CODE.CLAIM_DIV.KOHURI
        },
        updatetargetinfoClaimstatus: {
          claimSts: SgKdConstants.CODE.CLAIM_STS.REQRET
        },
        updatetargetinfoManualchargecalcJokyoflag: {},
        updatetargetinfoDryrskcalcStpflag: {}
      });
    }); 
    this.usedSgkd010dSgkd038aService.update(updateInfoArea)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        response.responseCommon.errors.forEach((error) => {
          this.setMessageEvent.emit(error.message);
        });
      }, error => {
      });
  }

  /**
   * yyyyMMddHHmm形式の文字列をDate型に変換する
   *
   * @param {string} date
   * @return {*}  {Date}
   * @memberof Sgkd010dSearchResultComponent
   */
  private convertStringToDate(date: string): Date | null {
    let result: Date | null = null;
    if (date && date != '') {
      const yyyy = Number(date.slice(0, 4));
      const MM = Number(date.slice(4, 6)) - 1;
      const dd = Number(date.slice(6, 8));
      const hour = Number(date.slice(8, 10));
      const minute = Number(date.slice(10, 12));
      result = new Date(yyyy, MM, dd, hour, minute);
    }
    return result;
  }
}
